var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconGdrive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_380",
    "data-name": "Group 380",
    transform: "translate(-2716 -22865)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_114",
    "data-name": "Rectangle 114",
    width: 50,
    height: 50,
    transform: "translate(2716 22865)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_7089491_drive_google_icon",
    "data-name": "7089491_drive_google_icon",
    transform: "translate(2720.86 22870)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M32.856,37.231c-.43.747-.239,1.35-.96,1.765a4.824,4.824,0,0,1-2.415.645h-16.7A4.833,4.833,0,0,1,10.371,39c-.722-.415-.531-1.019-.961-1.766L15.573,30h11.12Z",
    transform: "translate(-1.036 -4.716)",
    fill: "#1e88e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M26.783,6.923c.862,0,1.691-.575,2.411-.159a4.827,4.827,0,0,1,1.765,1.768l8.348,14.46a4.832,4.832,0,0,1,.649,2.412c0,.833-1.018,1.666-1.451,2.411L29.565,25.4,24,15.765Z",
    transform: "translate(-3.903 -0.12)",
    fill: "#fbc02d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M41.317,30a4.785,4.785,0,0,1-.651,2.41l-2.949,5.1A4.862,4.862,0,0,1,36.119,39l-5.2-9Z",
    transform: "translate(-5.262 -4.716)",
    fill: "#e53935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M5.592,27.815c-.432-.746-1.451-1.578-1.451-2.41a4.83,4.83,0,0,1,.649-2.414l8.348-14.46A4.829,4.829,0,0,1,14.9,6.764c.721-.417,1.55.157,2.412.158l2.779,8.846L14.533,25.4Z",
    transform: "translate(0 -0.12)",
    fill: "#4caf50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M14.537,30l-5.2,9a4.862,4.862,0,0,1-1.6-1.486l-2.949-5.1A4.785,4.785,0,0,1,4.14,30Z",
    transform: "translate(0 -4.716)",
    fill: "#1565c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M27.919,6.643l-5.191,9-5.2-9a4.775,4.775,0,0,1,2.089-.635L25.509,6A4.765,4.765,0,0,1,27.919,6.643Z",
    transform: "translate(-2.631)",
    fill: "#2e7d32"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGdrive);
export default __webpack_public_path__ + "static/media/icon-gdrive.e66a949a4ef10aee377c6710ccfa93a4.svg";
export { ForwardRef as ReactComponent };